import { useAppState } from 'Context/AppContext/AppContext'

const showRecurringTasks = 'showRecurringTasks'
const showPrioritiesStats = 'showPrioritiesStats'
const showFunderImpactNarrativesUpdates = 'showFunderImpactNarrativesUpdates'
const showImpactDashboardFilters = 'showImpactDashboardFilters'
const showCoachingCategoryAdvocacy = 'showCoachingCategoryAdvocacy'
const showEngagementDashboard = 'engagement-dashboard'
const funderEngagementDashboardMockData =
  'funder-engagement-dashboard-mock-data'
const showNonprofitFeed = 'showNonprofitFeed'
const enableMockData = 'useMockData'

const useAwsFlagActive = (
  featureFlagName: string,
  orgFeatureFlags?: string[]
) => {
  const { awsFeatureFlags } = useAppState()
  const { activeFeatureFlags } = awsFeatureFlags
  let canOrgSeeFeature = true

  if (orgFeatureFlags) {
    canOrgSeeFeature = Boolean(
      orgFeatureFlags.find((name) => name === featureFlagName)
    )
  }

  if (!canOrgSeeFeature) {
    return canOrgSeeFeature
  }

  return Boolean(activeFeatureFlags.includes(featureFlagName))
}

// Hook that checks URL parameters first, then falls back to AWS flags
const useFeatureFlagWithUrlOverride = (
  featureFlagName: string,
  orgFeatureFlags?: string[]
) => {
  // Always call the AWS flag hook (required for React hooks rules)
  const awsFlagValue = useAwsFlagActive(featureFlagName, orgFeatureFlags)

  // Check URL parameters for override
  const urlParams = new URLSearchParams(window.location.search)
  const urlOverride = urlParams.get(`ff-${featureFlagName}`)

  // Return URL override if present, otherwise return AWS flag value
  if (urlOverride !== null) {
    return urlOverride === 'true' || urlOverride === '1'
  }

  return awsFlagValue
}

export {
  useAwsFlagActive,
  useFeatureFlagWithUrlOverride,
  showRecurringTasks,
  showPrioritiesStats,
  showFunderImpactNarrativesUpdates,
  showImpactDashboardFilters,
  showCoachingCategoryAdvocacy,
  showEngagementDashboard,
  funderEngagementDashboardMockData,
  showNonprofitFeed,
  enableMockData,
}
